
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code1 } from "@/views/resources/documentation/element-ui/basic/link/code";

export default defineComponent({
  name: "basic",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code1
    };
  }
});
